<app-side-menu>
  <div class="external-provider-form-content">
    <!-- Loading State -->
    <app-loading [show]="isLoading || isSubmitting" [message]="isLoading ? 'Carregando prestador...' : 'Salvando...'"></app-loading>

    <!-- Header -->
    <div class="row mb-4" *ngIf="!isLoading">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <app-button
              text="Voltar"
              color="var(--secondary-color)"
              (buttonClick)="cancel()"
              className="me-3">
              <i class="fas fa-arrow-left me-2"></i>
            </app-button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-handshake me-3"></i>
                {{ providerId ? 'Editar Prestador Externo' : 'Novo Prestador Externo' }}
              </h1>
              <p class="page-subtitle">
                {{ providerId ? 'Atualize as informações do prestador de serviço externo' : 'Cadastre um novo prestador de serviço externo (B2B)' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row" *ngIf="!isLoading">
      <div class="col-12">
        <div class="external-provider-form-card">
          <form [formGroup]="form" (ngSubmit)="save()">
            <div class="row g-3">
              <div class="col-md-6">
                <label for="tradeName" class="form-label">Nome Fantasia *</label>
                <input
                  id="tradeName"
                  type="text"
                  class="form-control"
                  formControlName="tradeName"
                  placeholder="Ex: Auto Serviços XYZ">
              </div>

              <div class="col-md-6">
                <label for="companyName" class="form-label">Razão Social *</label>
                <input
                  id="companyName"
                  type="text"
                  class="form-control"
                  formControlName="companyName"
                  placeholder="Ex: XYZ Serviços Automotivos Ltda">
              </div>

              <div class="col-md-4">
                <label for="cnpj" class="form-label">CNPJ</label>
                <input
                  id="cnpj"
                  type="text"
                  class="form-control"
                  formControlName="cnpj"
                  (input)="onCnpjInput($event)"
                  placeholder="00.000.000/0000-00 (opcional)"
                  maxlength="18">
              </div>

              <div class="col-md-8">
                <label for="fullAddress" class="form-label">Endereço Completo</label>
                <input
                  id="fullAddress"
                  type="text"
                  class="form-control"
                  formControlName="fullAddress"
                  placeholder="Rua, número, bairro, cidade, UF, CEP">
              </div>

              <div class="col-md-4">
                <label for="phone" class="form-label">Telefone</label>
                <input
                  id="phone"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="phoneError"
                  formControlName="phone"
                  (input)="onPhoneInput($event)"
                  placeholder="(11) 3456-7890"
                  maxlength="15">
                <div *ngIf="phoneError" class="invalid-feedback d-block">
                  {{ phoneError }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="contactEmail" class="form-label">E-mail de Contato</label>
                <input
                  id="contactEmail"
                  type="email"
                  class="form-control"
                  formControlName="contactEmail"
                  placeholder="contato@empresa.com.br">
              </div>

              <div class="col-md-4">
                <label for="responsibleName" class="form-label">Responsável</label>
                <input
                  id="responsibleName"
                  type="text"
                  class="form-control"
                  formControlName="responsibleName"
                  placeholder="Nome do responsável comercial/técnico">
              </div>

              <div class="col-md-6">
                <label for="serviceType" class="form-label">Tipo de Serviço</label>
                <select
                  id="serviceType"
                  class="form-select"
                  [ngClass]="selectedServiceTypeClass"
                  formControlName="serviceType">
                  <option value="">Selecione o tipo de serviço</option>
                  <option *ngFor="let option of serviceTypesOptions" [value]="option.value"
                    [style.background-color]="option.bg"
                    [style.color]="option.text">
                    {{ option.label }}
                  </option>
                </select>
                <div class="service-type-legend mt-2">
                  <span *ngFor="let option of serviceTypesOptions"
                    class="service-type-chip"
                    [style.background-color]="option.bg"
                    [style.color]="option.text">
                    {{ option.label }}
                  </span>
                </div>
              </div>

              <div class="col-md-6">
                <label for="servedStates" class="form-label">
                  <i class="fas fa-map-marked-alt me-2"></i>
                  UFs atendidas <span class="text-danger">*</span>
                </label>
                <select
                  id="servedStates"
                  class="form-select states-select"
                  formControlName="servedStates"
                  multiple
                  size="8">
                  <option *ngFor="let state of statesOptions" [value]="state.value">
                    {{ state.label }}
                  </option>
                </select>
                <small class="text-muted d-block mt-1">
                  Segure Ctrl (Windows) ou Cmd (Mac) para marcar várias UFs. O portal B2B filtra oficinas por essa UF.
                </small>
                <div class="selected-chips mt-2" *ngIf="getSelectedStates().length">
                  <span class="badge bg-secondary me-1 mb-1" *ngFor="let uf of getSelectedStates()">
                    {{ uf }}
                    <button type="button" class="btn-chip-remove" (click)="removeState(uf)" title="Remover">×</button>
                  </span>
                </div>
                <div class="invalid-feedback d-block" *ngIf="form.get('servedStates')?.touched && form.get('servedStates')?.invalid">
                  Selecione ao menos uma UF.
                </div>
              </div>

              <div class="col-md-6">
                <label for="supportedVehicleTypes" class="form-label">
                  <i class="fas fa-car me-2"></i>
                  Tipos de Veículos Atendidos
                </label>
                <select
                  id="supportedVehicleTypes"
                  class="form-select vehicle-types-select"
                  formControlName="supportedVehicleTypes">
                  <option value="">Selecione os tipos de veículos atendidos</option>
                  <option *ngFor="let vehicle of vehicleTypesOptions" [value]="vehicle.value">
                    {{ vehicle.label }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="businessHours" class="form-label">Horário de Funcionamento</label>
                <input
                  id="businessHours"
                  type="text"
                  class="form-control"
                  formControlName="businessHours"
                  placeholder="Ex: Segunda a Sexta: 8h às 18h | Sábado: 8h às 12h">
              </div>

              <div class="col-md-6">
                <label for="pixKey" class="form-label">Chave PIX</label>
                <input
                  id="pixKey"
                  type="text"
                  class="form-control"
                  formControlName="pixKey"
                  placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"
                  maxlength="200">
                <small class="text-muted">Opcional. Aceita qualquer formato de chave PIX.</small>
              </div>
            </div>

            <!-- Seção de Documentos -->
            <div class="documents-section mt-4">
              <h3 class="section-title mb-3">
                <i class="fas fa-file-upload me-2"></i>
                Documentos (6 por padrão)
              </h3>
              <p class="text-muted mb-4">
                <i class="fas fa-info-circle me-2"></i>
                Selecione os arquivos dos documentos obrigatórios. Os arquivos serão enviados para o Blob Storage automaticamente.
              </p>

              <div class="row g-3">
                <div class="col-12" *ngFor="let doc of documents; let i = index">
                  <div class="document-item card p-3">
                    <div class="row align-items-center">
                      <div class="col-md-3">
                        <label class="form-label fw-bold">{{ doc.documentName }}</label>
                        <small class="text-muted d-block">{{ doc.documentType }}</small>
                      </div>
                      <div class="col-md-4">
                        <input
                          type="text"
                          class="form-control form-control-sm mb-2"
                          [(ngModel)]="doc.documentName"
                          [ngModelOptions]="{standalone: true}"
                          placeholder="Nome do documento">
                        <select
                          class="form-select form-select-sm"
                          [(ngModel)]="doc.documentType"
                          [ngModelOptions]="{standalone: true}">
                          <option *ngFor="let docType of documentTypesOptions" [value]="docType.value">
                            {{ docType.label }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-4">
                        <div class="input-group">
                          <input
                            type="file"
                            [id]="'fileInput' + i"
                            class="form-control form-control-sm"
                            (change)="onFileSelected($event, i)"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx">
                          <button
                            *ngIf="doc.file"
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            (click)="removeFile(i)">
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                        <small *ngIf="doc.file" class="text-success d-block mt-1">
                          <i class="fas fa-check-circle me-1"></i>
                          Novo arquivo: {{ doc.file.name }}
                        </small>
                        <div *ngIf="!doc.file && doc.documentUrl" class="mt-1">
                          <a [href]="doc.documentUrl" target="_blank" class="btn btn-sm btn-outline-primary">
                            <i class="fas fa-external-link-alt me-1"></i>
                            Ver Documento Existente
                          </a>
                        </div>
                        <small *ngIf="!doc.file && !doc.documentUrl" class="text-warning d-block mt-1">
                          <i class="fas fa-exclamation-triangle me-1"></i>
                          Sem documento
                        </small>
                      </div>
                      <div class="col-md-1 text-end">
                        <span class="badge bg-primary">#{{ i }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ações -->
            <div class="form-actions mt-4 d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="cancel()">
                Cancelar
              </button>

              <button
                type="submit"
                class="btn btn-success"
                [disabled]="isSubmitting">
                {{ isSubmitting ? 'Salvando...' : 'Salvar Prestador' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>


